<script>
// import simplebar from "simplebar-vue";
import { layoutComputed } from "@/state/helpers";

export default {
  data() {
    return {
      clientData: JSON.parse(localStorage.getItem("client")),
    };
  },
  computed: {
    ...layoutComputed,
  },
  
  methods: {
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
  },
};
</script>

<template>
  <header id="page-topbar" style="background-color:beige;">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm"><img src="@/assets/images/logo.png" alt height="30" /></span>
            <span class="logo-lg"><img src="@/assets/images/logo.png" height="40" /></span>
          </router-link>
        </div>
        <button id="toggle" type="button" class="btn btn-sm me-2 font-size-16 d-lg-none header-item" @click="toggleMenu"><i class="fa fa-fw fa-bars text-black"></i></button>
      </div>

      <div class="d-flex">
        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button type="button" class="btn header-item noti-icon" @click="initFullScreen" ><i class="bx bx-fullscreen"></i></button>
        </div>
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img class="rounded-circle header-profile-user" src="@/assets/images/user.png" />
            <span class="d-none d-xl-inline-block ms-1 text-dark">{{ clientData.fullname }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block text-dark"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> logout
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
